<template>
  <div class="Register-Container">
    <img :src="splashUrl" alt="" class="splashImg" />
    <div class="backArow" @click="$router.push('PreRegister')">
      <img src="@/assets/arow.svg" alt="" />
    </div>

    <div class="register-form">
      <div class="top-right-icons">
        <div class="top-right-button" data-cy="header.language">
          <language-dropdown />
        </div>
      </div>
      <form @submit.prevent="registerUser">
        <img src="@/assets/logo.png" class="logo" />
        <h1>{{ $t('auth.register.addInfos') }}</h1>
        <h3>{{ $t('auth.register.optionalPersonnalData') }}</h3>

        <div class="inputForm">
          <vv-form-text-input
            v-if="registerFields.phone !== undefined"
            label="phone"
            id="phone"
            v-model="phone"
            placeholder="0651267526"
            :validate="registerFields.phone.mandatory ? 'numeric' : 'numeric'"
          />

          <vv-form-text-input
            v-if="registerFields.address !== undefined"
            label="address"
            id="address"
            v-model="shippingAddress"
            :validate="registerFields.address.mandatory ? '' : ''"
            placeholder="8 Avenue de la mer"
          />
          <vv-form-text-input label="city" id="city" v-model="city" placeholder="Paris" />

          <vv-form-text-input
            v-if="registerFields.postalCode !== undefined"
            label="postalCode"
            id="postal-code"
            v-model="shippingPostalCode"
            :validate="registerFields.postalCode.mandatory ? 'numeric' : 'numeric'"
            placeholder="75000"
          />

          <vv-form-text-input label="country" id="country" v-model="country" placeholder="France" />

          <div class="gender-wrapper">
            <vv-radio-bubble
              v-for="genderItem in genderList"
              name="genderRadioBubbles"
              :key="genderItem.value"
              :value="genderItem.value"
              :label="genderItem.label"
              v-model="gender"
            />
          </div>
        </div>

        <validate-form-button
          @click="registerUser"
          :isLoading="loading"
          label="auth.register.callToSubmit"
          class="btCreate"
        />
      </form>
    </div>
  </div>
</template>

<script>
import { REGISTER_USER } from '@/store/modules/user/types'
import ValidateFormButton from '@/components/common/ValidateFormButton'
import VvFormTextInput from '@/components/common/forms/VvFormTextInput'
import VvRadioBubble from '@/components/common/VvRadioBubble'
import userMixin from '@/mixins/user'
import { SNACKBAR_MESSAGE } from '@/helpers/eventBus'
import * as types from '@/store/modules/user/types'
import { SIGNIN_USER } from '@/store/modules/user/types'
import { splash_screen_url } from '@/lib/remote-config/constants'
import remoteConfig from '@/lib/remote-config'
import LanguageDropdown from '@/components/language/LanguageDropdown'
import { SET_FORM_USER_INFORMATIONS } from '@/store/modules/user/types'

export default {
  name: 'Register',
  mixins: [userMixin],
  components: {
    ValidateFormButton,
    VvFormTextInput,
    VvRadioBubble,
    LanguageDropdown
  },
  data: () => ({
    username: '',
    password: '',
    gender: '',
    loading: false,
    firstname: '',
    lastname: '',
    birthday: '',
    phone: '',
    shippingAddress: '',
    city: '',
    country: '',
    shippingPostalCode: '',
    newsletter: '',
    acceptCondition: '',
    splashUrl: '',
    local: 'fr-FR'
  }),
  methods: {
    registerUser: async function() {
      const result = await this.$validator.validateAll()
      if (!result) {
        return
      }

      this.loading = true
      const [error, response] = await this.$store.dispatch(REGISTER_USER, {
        username: this.username,
        password: this.password,
        gender: this.gender,
        firstname: this.firstname,
        lastname: this.lastname,
        birthday: this.birthday,
        phone: this.phone,
        shippingAddress: this.shippingAddress,
        city: this.city,
        country: this.country,
        shippingPostalCode: this.shippingPostalCode,
        newsletter: this.newsletter,
        acceptCondition: this.acceptCondition,
        language: this.local
      })
      if (error || response.data.error) {
        if (error && error.code) {
          this.$eventBus.$emit(SNACKBAR_MESSAGE, { message: this.$t('errors.' + error.code) })
        } else if (response.data.error) {
          this.$eventBus.$emit(SNACKBAR_MESSAGE, {
            message: this.$t('errors.' + response.data.reason)
          })
        } else {
          this.$eventBus.$emit(SNACKBAR_MESSAGE, {
            message: this.$t('errors.custom/internal-error')
          })
        }
      } else {
        this.$store.commit(SET_FORM_USER_INFORMATIONS, {})
        if (response.data.emailVerified) {
          // Force log the user
          await this.$store.dispatch(SIGNIN_USER, {
            username: this.username,
            password: this.password
          })
        } else {
          this.$store.commit(types.REGISTER_USER, { email: this.username, validated: false })

          this.$router.push({
            name: 'confirm-registration'
          })
        }
      }

      this.loading = false
    },
    getSelect(selectId) {
      var selectElmt = document.getElementById(selectId)
      return selectElmt.value
    }
  },
  computed: {
    registerFields() {
      try {
        // console.log('registerfields', JSON.parse(remoteConfig.getString('register_fields')))
        return JSON.parse(remoteConfig.getString('register_fields'))
      } catch (error) {
        return {}
      }
    },
    genderList() {
      return [
        { label: this.$t('forms.gender.female'), value: 'female' },
        { label: this.$t('forms.gender.male'), value: 'male' }
      ]
    },
    languageSelected() {
      const languages = remoteConfig.getString('languages')

      if (languages) {
        return languages
          .split('|')
          .map(language => ({ value: language, text: this.$t(`languages.${language}`) }))
      }
      return []
    }
  },
  mounted() {
    this.splashUrl = remoteConfig.getString(splash_screen_url)
    this.firstname = this.$store.state.user.formUserInformations.firstname
    this.lastname = this.$store.state.user.formUserInformations.lastname
    this.username = this.$store.state.user.formUserInformations.username
    this.password = this.$store.state.user.formUserInformations.password
    this.birthday = this.$store.state.user.formUserInformations.birthday
    this.newsletter = this.$store.state.user.formUserInformations.newsletter
    this.acceptCondition = this.$store.state.user.formUserInformations.acceptCondition
    if (this.isUserLogged) {
      this.$router.push({ name: 'home' })
      return
    }
  },
  watch: {
    isUserLogged(newState) {
      if (newState) {
        // Automatically logged
        this.$router.push({ name: 'home' })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.top-right-icons {
  position: absolute;
  top: 35px;
  right: 35px;
  display: flex;
  cursor: pointer;
  justify-content: flex-end;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  font-family: 'Helvetica', sans-serif;
  max-width: 80000px;
  background-color: white;
  border-radius: 13px;
  position: absolute;
  top: 25px;
  .top-right-button {
    // min-width: 80px;
    width: 40px;
    height: 30px;
    padding: 5px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
  }
}
form {
  width: 415px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  h1 {
    width: 100%;
    text-align: center;
    letter-spacing: 0px;
    color: #404040;
    opacity: 1;
    font-weight: 400;
    margin: 10px;
  }
  h3 {
    width: 700px;
    text-align: center;
    letter-spacing: 0px;
    color: #404040;
    opacity: 1;
    font-weight: 300;
    margin: 10px;
  }
}

.Register-Container {
  width: 100vw;
  height: 100vh;
  font-family: 'DM Sans', sans-serif;
}

.register-form {
  float: right;
  margin-right: 10%;
  margin-top: 8%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 500px;
  height: 600px;
  padding: 50px;
  background: #f8f6ef 0% 0% no-repeat padding-box;
  border-radius: 45px;
  background-color: rgba(248, 246, 239, 0.67);
}

.textGras {
  font-weight: 700;
}
.language {
  margin-top: 5px;
}

.backArow {
  position: fixed;
  top: 20px;
  left: 20px;
  transform: rotate(180deg);
  width: 40px;
  cursor: pointer;
}

.splashImg {
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0px;
  left: 0px;
  object-fit: cover;
  z-index: -1;
}

.selectLang {
  width: 100%;
  margin-top: 1%;
  margin-bottom: 1.5%;
}

.inputForm {
  width: 100%;
  display: flex;
  align-items: stretch;
  justify-content: center;
  flex-direction: row;
  flex-wrap: wrap;
  max-width: 1000px;
}

.formBox {
  width: 300px;
  margin: 20px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.formBox > * {
  margin: 4px 0px;
}

.city {
  display: flex;
  flex-wrap: wrap;
}

.gender-wrapper {
  margin: 3.5px 0px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.gender-label {
  display: block;
}

.endBox {
  align-self: flex-start;
  margin-left: 5px;
  margin-top: 10px;
}

.btCreate {
  margin-top: 25px;
  width: 100%;
  display: flex;
  justify-content: center;
}

.logo {
  width: 100px;
  margin-bottom: 10px;
}

// @media (max-width: 679px) {
//   .endBox {
//     width: 300px;
//     margin: 20px;
//   }
//   .backArow {
//     width: 30px;
//   }
// }

@media (max-width: 1024px) {
  .backArow {
    width: 30px;
  }
  .Register-Container {
    width: 100vw;
    height: 100vh;
    font-family: 'DM Sans', sans-serif;
  }

  .register-form {
    margin-right: 10%;
    margin-top: 18%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 450px;
    height: 600px;
    background: #f8f6ef 0% 0% no-repeat padding-box;
    border-radius: 45px;
    background-color: rgba(248, 246, 239, 0.67);
  }
}

@media all and (max-width: 620px) {
  .logo {
    width: 100px;
    margin-bottom: 10px;
  }
  h1 {
    display: none;
  }
  form h3 {
    width: 75%;
  }
  .Register-Container {
    display: flex;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    font-family: 'DM Sans', sans-serif;
  }

  .register-form {
    margin-right: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 250px;
    height: 550px;
    padding: 50px;
    background: #f8f6ef 0% 0% no-repeat padding-box;
    border-radius: 45px;
    background-color: rgba(248, 246, 239, 0.67);
  }
  form {
    margin-top: -15px;
  }
  .backArow {
    width: 30px;
  }
  .endBox {
    margin-left: 67px;
    margin-top: 10px;
    width: 65%;
  }
}
</style>
